import React from 'react';
import axios from 'axios';
import InputMask from 'react-input-mask';

import Loading from '../Loading';

import InputApplicantSelector from '../InputSpecialFields/InputApplicantSelector';

import IconContainer from '../../Components/IconContainer';
import { ReactComponent as XIcon } from '../../icons/x-close.svg';
import { ReactComponent as PlusIcon } from '../../icons/plus.svg';

export default function AddNewApplicantToCase({ caseId, formInfo, setFormInfo, access, userId, onSuccess }) {
    const [isPanelOpen, setIsPanelOpen] = React.useState(false);
    const [loading, setLoading] = React.useState(false);
    const [status, setStatus] = React.useState('');

    const [errorsForm, setErrorsForm] = React.useState({

    });

    const attachNewdebtorName = () => {
        const token = localStorage.getItem('token');

        setLoading(true);

        axios.post('/api/add-new-case-applicant',
            {
                case_id: caseId,
                applicant_id: formInfo.applicant_id,
                applicant_name: formInfo.applicant_name,
            },
            {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            }
        ).then(() => {
            onSuccess();
            setIsPanelOpen(false);
        }).catch((error) => {
            console.error(error);
            setStatus(<a className='mainLabelError'>{error.response?.data.message || 'Произошла неизвестная ошибка. Попробуйте повторить позднее'}</a>);
        }).finally(() => {
            setLoading(false);
        });
    }

    return (
        isPanelOpen ? 
            <div className='panel'>
                <div className='panelHeader'>
                    <h3>Добавление заявителя к карточке</h3>
                    <IconContainer 
                        Icon={XIcon} 
                        onClick={() => {
                            setIsPanelOpen(false);
                        }} 
                        size = '17' 
                        color = 'black' 
                        className = '' 
                    />
                </div>
                <div className='panelMain'>
                    <div className='labelInputRight'>
                        <div className='inputWrapper'>
                            <InputApplicantSelector
                                initialSearchTerm={formInfo.applicant_name}
                                formInfo={formInfo}
                                setFormInfo={setFormInfo}
                                errorsForm={errorsForm}
                                setErrorsForm={setErrorsForm}
                                isAddNew={true}
                            />
                        </div>
                    </div>
                </div>
                <div className='panelBottom'>
                    <div>{status}</div>
                    {loading ? 
                        <Loading type='inline' />
                    :
                        <button 
                        type='button' 
                        className='button' 
                        onClick={attachNewdebtorName}
                        disabled={loading}
                        >
                            Добавить
                        </button>
                    }
                </div>
            </div>
        :   <button 
                type='button' 
                className='button miniButton' 
                onClick={() => {setIsPanelOpen(true)}}
            >
                <PlusIcon />
                Добавить заявителя
            </button>
    )
}
